export default __webpack_public_path__ + "static/media/chevron-left.baf88cc3.svg";